import { connect } from 'react-redux'
import PersonalInfoPane from '../../../components/riders/editrider/personalinfo/PersonalInfoPane'
import * as actions from '../../../state/actions/riders'
import { IRiderObject, IStoreState } from '../../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {}
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateRiderPersonalInfo: (rider: IRiderObject): Promise<any> => {
      return dispatch(actions.updateRiderPersonalInfo(rider))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalInfoPane)



// WEBPACK FOOTER //
// ./src/containers/riders/editrider/PersonalInfoPane.ts